module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_01_1280_1280_vi-b385adb7ceb5919de732cf3f420a9cd7.jpg";